export default function BankDetailsStep({ data, setData }) {

    const handleChange = (e) => {
        const { name, value } = e.target;

        setData({
            ...data,
            [name]: value
        });
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;

        setData({
            ...data,
            [name]: files[0]
        });
    };

    return (
        <div>
            <h2 className="h4 fw-semibold text-dark mb-4">
                Enter Bank Details
            </h2>

            <div className="card shadow-sm border-0 rounded-3">
                <div className="card-body p-4">

                    <div className="d-flex gap-4">
                        <div className="w-50">
                            <label>Account Holder Name *</label>
                            <input
                                type="text"
                                name="account_holder"
                                value={data.account_holder || ""}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        <div className="w-50">
                            <label>Bank Name *</label>
                            <input
                                type="text"
                                name="bank_name"
                                value={data.bank_name || ""}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>
                    </div>

                    <div className="d-flex gap-4 mt-3">
                        <div className="w-50">
                            <label>Account Number *</label>
                            <input
                                type="text"
                                name="account_number"
                                value={data.account_number || ""}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        <div className="w-50">
                            <label>IFSC Code *</label>
                            <input
                                type="text"
                                name="ifsc"
                                value={data.ifsc || ""}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>
                    </div>

                    <div className="mt-3">
                        <label>Cancelled Cheque *</label>
                        <input
                            type="file"
                            name="cheque"
                            onChange={handleFileChange}
                            className="form-control"
                        />
                    </div>

                </div>
            </div>
        </div>
    );
}
